import React from 'react';

import { MainButton } from 'components/Button';
import QuestionMark from 'icons/question-mark.svg';
import TrashIcon from 'icons/trash.svg';

import { AttachFileNoteList } from './AttachFileNoteList';
import FileItem from './FileItem';

export interface IFileItem {
  isChecked: boolean;
  file: File;
}

interface Props {
  inputRef: React.RefObject<HTMLInputElement>;
  isFileSizeValid: boolean;
  isFilesMaxCountValid: boolean;
  files: IFileItem[];
  onItemChange: (fileName: string) => void;
  onRemove: () => void;
  onChange: () => void;
  disabled?: boolean;
  contactFormRole: string;
}

const ATTACH_FILE = 'Attach file';
const TOTAL_SIZE = 'The total size of attachments should not exceed 10 MB.';
const SIZE_IS_TOO_HIGH = 'The total size is more than 10 MB';
const INPUT_VALIDATION = 'File limit exceeded. Please select up to 20 files.';
const ALLOWED_TYPES = 'Allowed types:';
const REMOVE_SELECTED = 'Remove selected';
const FILE_EXTENSIONS =
  '.jpg,.jpeg,.png,.gif,.doc,.docx,.ppt,.pptx,.pdf,.txt,.rtf,.odt,.ods,.odg,.odp,.xls,.xlsx,.xlxs,.vcf,.vcard,.key,.rar,.zip,.7z,.gz,.gzip,.tar,';

export const FileInput = ({
  inputRef,
  files,
  isFileSizeValid,
  isFilesMaxCountValid,
  onChange,
  onItemChange,
  onRemove,
  disabled,
  contactFormRole,
}: Props) => {
  return (
    <div className="attachment">
      <div className="attachment-container">
        <label htmlFor="attachment">
          <MainButton
            className="button outlined"
            component="span"
            disabled={disabled}
            label={ATTACH_FILE}
            type="button"
          >
            {ATTACH_FILE}
          </MainButton>
        </label>
        <input
          ref={inputRef}
          type="file"
          id="attachment"
          className="attach-file"
          accept={FILE_EXTENSIONS}
          aria-label="attach files"
          multiple
          onChange={onChange}
          disabled={disabled}
          // eslint-disable-next-line react/no-unknown-property
          contact-form-role={contactFormRole}
        />
        <div className="attach-file-mark">
          <QuestionMark />
          <div className="attach-file-note">
            <p className="attach-file-note-paragraph">{TOTAL_SIZE}</p>
            <p className="attach-file-note-paragraph">{ALLOWED_TYPES}</p>
            <AttachFileNoteList />
          </div>
        </div>
      </div>
      <div className="file-list">
        {!isFileSizeValid && <p className="validation-message">{SIZE_IS_TOO_HIGH}</p>}
        {!isFilesMaxCountValid && <p className="validation-message">{INPUT_VALIDATION}</p>}
        {files.map((fileItem) => (
          <FileItem key={fileItem.file.name} file={fileItem.file} onChange={onItemChange} disabled={disabled} />
        ))}
      </div>
      {files.length > 0 && (
        <MainButton
          className="button outlined"
          onClick={onRemove}
          component="span"
          disabled={disabled}
          label={REMOVE_SELECTED}
          type="button"
        >
          <TrashIcon />
          {REMOVE_SELECTED}
        </MainButton>
      )}
    </div>
  );
};
